var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons / 20 / zap",
    clipPath: "url(#clip0_101_61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.2755 2.07129L2.60885 10.0713H8.60884L7.94217 15.4046L14.6088 7.40461H8.60884L9.2755 2.07129Z",
    stroke: "#E3C050",
    strokeWidth: 1.336,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_61"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.608856 0.737305)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.978bf7f624cad9130374b1592bb3efb6.svg";
export { ForwardRef as ReactComponent };